import { IconX } from '@tabler/icons-react'

import { Button } from './Button'

type Props = {
	onClick: () => void
}

export const ButtonClear = ({ onClick }: Props) => (
	<Button onClick={onClick}>
		<IconX size={20} />
	</Button>
)
